import IDoorMetaData from 'components/interfaces/IDoorMetaData';
import { TSH } from 'services/constants/glassEdgeTreatmentTypes';
import { FLOAT } from 'services/constants/glassPropertyTypes';
import { LAMINATED } from 'services/constants/glassTreatmentTypes';

const getDefaultDoorMetaData = (): IDoorMetaData => ({
  aboveGlassEdgeTreatmentType: TSH,
  aboveGlassGlassPropertyType: FLOAT,
  aboveGlassGlassTreatmentType: LAMINATED,
  aboveGlassId: '',
  aboveGlassName: '',
  aboveGlassNotice: '',
  doorId: '',
  doorTempId: 0,
  primaryGlassEdgeTreatmentType: TSH,
  primaryGlassGlassPropertyType: FLOAT,
  primaryGlassGlassTreatmentType: LAMINATED,
  primaryGlassId: '',
  primaryGlassName: '',
  primaryGlassNotice: '',
  secondaryGlassEdgeTreatmentType: TSH,
  secondaryGlassGlassPropertyType: FLOAT,
  secondaryGlassGlassTreatmentType: LAMINATED,
  secondaryGlassId: '',
  secondaryGlassName: '',
  secondaryGlassNotice: '',
  sideGlassLeftEdgeTreatmentType: TSH,
  sideGlassLeftGlassPropertyType: FLOAT,
  sideGlassLeftGlassTreatmentType: LAMINATED,
  sideGlassLeftId: '',
  sideGlassLeftName: '',
  sideGlassLeftNotice: '',
  sideGlassRightEdgeTreatmentType: TSH,
  sideGlassRightGlassPropertyType: FLOAT,
  sideGlassRightGlassTreatmentType: LAMINATED,
  sideGlassRightId: '',
  sideGlassRightName: '',
  sideGlassRightNotice: '',
});

export default getDefaultDoorMetaData;
